import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatProgressBar } from "@angular/material/progress-bar";
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { DecimalPipe } from "@angular/common";
import { DetectionService } from "../../../services/detection/detection.service";

@Component({
  selector: "lib-processing-overlay",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatProgressSpinner, MatProgressBar, MatButton, MatIcon, DecimalPipe],
  templateUrl: "./processing-overlay.component.html",
  styleUrl: "./processing-overlay.component.scss",
})
export class ProcessingOverlayComponent {
  protected readonly detection = inject(DetectionService);
}
